import { render, staticRenderFns } from "./FormValidationLocale.vue?vue&type=template&id=2205e3b4&"
import script from "./FormValidationLocale.vue?vue&type=script&lang=js&"
export * from "./FormValidationLocale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports